export default "__VITE_ASSET__3e311251__"